import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { logout as logoutAction } from 'store/modules/auth/actions';
import constructEnterpriseDomain from 'utils/construct-enterprise-domain';

/**
 * User-initiated logout on the current origin with a hard reload on `app.{brand}/clear`,
 * because Auth0 token storage is per-origin.
 */
export function useLogoutWithAppClear() {
  const dispatch = useDispatch();
  const { logout: auth0Logout } = useAuth0();

  return useCallback(() => {
    auth0Logout({ logoutParams: { returnTo: `${constructEnterpriseDomain()}/clear` } });
    dispatch(logoutAction());
  }, [auth0Logout, dispatch]);
}
